module.exports = __webpack_public_path__ + "static/media/print.f08ad43a.svg";